import { documentHasElements } from "modules/dom";

documentHasElements(".js-hero-video-block", (heroVideoBlocks) => {
    heroVideoBlocks.forEach((heroVideoBlock) => {

        const youtubeImageContainer = heroVideoBlock.querySelector<HTMLElement>(".youtube .image-container");
        const youtubeVideoContainer = heroVideoBlock.querySelector<HTMLDivElement>(".youtube .video-container");
        const youtubeCloseButton = heroVideoBlock.querySelector<HTMLDivElement>(".youtube .video-container button");
        const youtubeEmbedUrl = heroVideoBlock.querySelector<HTMLDivElement>(".youtube .embed-url")?.innerHTML;

        let isPlaying = false;

        youtubeImageContainer?.addEventListener("click", () => {
            if (isPlaying) return;
            isPlaying = true;

            setTimeout(() => {
                const iframe = document.createElement('iframe');
                iframe.setAttribute('src', `https://www.youtube.com/embed/${youtubeEmbedUrl}?autoplay=1&rel=0&showinfo=0`);
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
                iframe.setAttribute('allowfullscreen', 'allowfullscreen');
                iframe.setAttribute('width', '100%');
                iframe.setAttribute('height', 'auto');

                youtubeVideoContainer?.appendChild(iframe);
                youtubeImageContainer?.classList.add("scaled");
            }, 900);

            setTimeout(() => {
                youtubeImageContainer?.classList.add("played");
            }, 4000);

            setTimeout(() => {
                youtubeVideoContainer?.classList.add("played");
            }, 5000);

        });

        youtubeCloseButton?.addEventListener("click", () => {

            const youtubeVideo = heroVideoBlock.querySelector<HTMLDivElement>(".youtube iframe");
            youtubeVideoContainer?.classList.add("closed");  
            
            setTimeout(() => {
                youtubeImageContainer?.classList.remove("scaled");
                youtubeImageContainer?.classList.remove("played");
                youtubeVideoContainer?.classList.remove("played");
                youtubeVideoContainer?.classList.remove("closed");  

                youtubeVideo?.remove();
                isPlaying = false;
            }, 600);
        });

    });
});